import insertText from './insertText';
import removeText from './removeText';
const mappers = {
    insert_text: insertText,
    remove_text: removeText,
};
export default mappers;
